export default
  scriptExpando: 'script'